function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgRegisteredTrademark = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "16pt",
  height: "16pt",
  viewBox: "0 0 16 16"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M188.477 100c0 48.877-39.6 88.477-88.477 88.477S11.523 148.877 11.523 100 51.123 11.523 100 11.523s88.477 39.6 88.477 88.477Zm0 0",
  style: {
    fill: "none",
    strokeWidth: 20,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    stroke: "#000",
    strokeOpacity: 1,
    strokeMiterlimit: 4
  },
  transform: "scale(.08)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.566 7.36q.664-.002.954-.255c.19-.16.296-.433.296-.816 0-.379-.105-.64-.296-.809q-.29-.241-.954-.242h-.894V7.36zm-.894 1.465v3.121H4.543v-8.25h3.25q1.628 0 2.383.551c.511.363.761.938.761 1.73 0 .544-.128.993-.394 1.344-.262.344-.656.61-1.191.77.296.07.55.223.785.453.23.234.465.586.695 1.066l1.16 2.336H9.727l-1.008-2.05c-.2-.407-.406-.696-.614-.84q-.315-.23-.832-.23z",
  style: {
    stroke: "none",
    fillRule: "nonzero",
    fill: "#000",
    fillOpacity: 1
  }
}));
export { SvgRegisteredTrademark as ReactComponent };
export default __webpack_public_path__ + "static/media/registered-trademark.a9cca7fc.svg";